import { combineReducers } from 'redux';

import authReducer from './authReducer';
import errorReducer from './errorReducer';
import feedbackReducer from './feedbackReducer';
import loadingReducer from './loadingReducer';
import paymentReducer from './paymentReducer';
import userReducer from './userReducer';
import jobReducer from './jobReducer';
import messageReducer from './messageReducer';
import alertsReducer from './alertsReducer';
import multidayReducer from './multidayReducer';
import messagesReducer from './messagesReducer';
import ppReducer from './ppReducer';

// right now we have only 1 reducer, but lets use this format of combineReducers so you can add more later if you need to.
export default combineReducers({
  auth: authReducer,
  user: userReducer,
  error: errorReducer,
  loading: loadingReducer,
  feedback: feedbackReducer,
  payments: paymentReducer,
  job: jobReducer,
  message: messageReducer,
  alerts: alertsReducer,
  multiday: multidayReducer,
  messages: messagesReducer,
  pp: ppReducer,
});
